var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashboardItemDebtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6_4_",
    "data-name": "svgexport-6 (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.471,
    height: 44.471,
    viewBox: "0 0 44.471 44.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11774",
    "data-name": "Group 11774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M131.58,97.173V91.3a1.3,1.3,0,0,0-2.606,0v5.87a3.907,3.907,0,0,0-2.224,5.369l-4.151,4.151a1.3,1.3,0,0,0,1.843,1.843l4.151-4.151a3.908,3.908,0,1,0,2.987-7.211Zm-1.3,4.987a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,130.277,102.16Z",
    transform: "translate(-111.603 -82.183)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M348.9,306.018l-.389-.14v-2.612a1.457,1.457,0,0,1,.263.166,1.067,1.067,0,0,0,.731.284,1.085,1.085,0,0,0,.736-1.883,3.9,3.9,0,0,0-1.73-.857v-.39a1.086,1.086,0,1,0-2.171,0v.462l-.063.018a3.29,3.29,0,0,0-2.258,2.577,2.939,2.939,0,0,0,.977,2.893,6.853,6.853,0,0,0,1.344.8v3.644a2.95,2.95,0,0,1-1-.472,1.086,1.086,0,1,0-1.189,1.817,4.7,4.7,0,0,0,2.187.853v.44a1.086,1.086,0,1,0,2.171,0v-.548a3.947,3.947,0,0,0,2.754-3.108A3.481,3.481,0,0,0,348.9,306.018Zm-2.56-1.188,0,0a.826.826,0,0,1-.183-.783,1.366,1.366,0,0,1,.187-.47Zm2.784,4.768a1.788,1.788,0,0,1-.613,1.065V308.22a1.286,1.286,0,0,1,.613,1.378Z",
    transform: "translate(-313.812 -273.486)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M36.788,23.231A18.661,18.661,0,1,0,23.231,36.788,10.858,10.858,0,1,0,36.788,23.231ZM22.774,34.212a15.99,15.99,0,0,1-2.8.476V33.44a1.3,1.3,0,0,0-2.606,0v1.25a16,16,0,0,1-9.1-3.775l.878-.878a1.3,1.3,0,0,0-1.843-1.843l-.878.878a16,16,0,0,1-3.775-9.1h1.25a1.3,1.3,0,1,0,0-2.606H2.659a16,16,0,0,1,3.775-9.1l.878.878A1.3,1.3,0,0,0,9.155,7.312l-.878-.878a16,16,0,0,1,9.1-3.775v1.25a1.3,1.3,0,1,0,2.606,0V2.659a16,16,0,0,1,9.1,3.775l-.878.878a1.3,1.3,0,0,0,1.843,1.843l.878-.878a16,16,0,0,1,3.775,9.1H33.44a1.3,1.3,0,0,0,0,2.606h1.248a16,16,0,0,1-.476,2.8q-.3-.016-.6-.017A10.87,10.87,0,0,0,22.757,33.614Q22.757,33.915,22.774,34.212Zm10.841,7.653a8.252,8.252,0,1,1,8.252-8.252A8.261,8.261,0,0,1,33.614,41.866Z",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashboardItemDebtIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashboard-item-debt-icon.33aa1ef08b7da6af943ffb17b297430a.svg";
export { ForwardRef as ReactComponent };